import {config} from "@/config/config";

export default async function disclaimerRouteGuard(to, from, next) {
  const chatbot = new URLSearchParams(window.location.search).get("botName");
  if (config.casProtectedBots.includes(chatbot)) {
    if (!localStorage.getItem("consented")) {
      console.log("Disclaimer route guard activated.");
      localStorage.setItem("savedFullPath", to.fullPath+"?botName=" + chatbot);
      return next("/disclaimer/" + chatbot);
    }
  }
  return next();
}
